<template>
  <div
    class="tile"
    :class="tileClass"
    @click="onClickTile"
  >
    {{ tileLabel }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NS_GAME_STATE } from "@/store/constants";
import {
  HOTEL_TOWER,
  HOTEL_LUXOR,
  HOTEL_WORLDWIDE,
  HOTEL_AMERICAN,
  HOTEL_FESTIVAL,
  HOTEL_IMPERIAL,
  HOTEL_CONTINENTAL,
} from "@/store/game/constants";

export default {
  name: 'GameTile',

  props: {
    hotelId: {
      type: [String, Boolean],
      default: '',
    },

    isEmpty: {
      type: Boolean,
      default: false,
    },

    tileId: {
      type: String,
      default: '',
    },

    isChildHotel: {
      type: Boolean,
      default: false,
    },

    hidden: {
      type: Boolean,
      default: false,
    },

    myTile: {
      type: Boolean,
      default: false,
    },

    // onBoard: {
    //   type: Boolean,
    //   default: false,
    // },
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'selectedTile',
    ]),

    isCurrentTile() {
      return this.tileId === this.selectedTile;
    },

    tileLabel() {
      if (this.hotelId && !this.isChildHotel) {
        return this.hotelId.split('')[0];
      }

      // if (this.isChildHotel) {
      //   return this.hotelId.split('')[0];
      // }

      return this.tileId;
    },

    tileClass() {
      const classes = [];

      if (this.hotelId) {
        classes.push(this.hotelTileClass);
      }

      if (this.hotelId && this.isChildHotel) {
        classes.push('child-hotel-tile');
      }

      if (this.hotelId && !this.isChildHotel) {
        classes.push('parent-hotel-tile');
        // if (this.onBoard) {
        //   classes.push('parent-hotel-tile-on-board');
        // }
      }

      if (this.hidden) {
        classes.push('hidden');
      }

      if (!this.isEmpty) {
        classes.push('raised-tile');
      }

      if (this.isCurrentTile) {
        classes.push('current')
      }

      if (this.myTile) {
        classes.push('my-tile');
      }

      return classes.join(' ');
    },

    hotelTileClass() {
      switch (this.hotelId) {
        case HOTEL_TOWER:
          return 'tile-TOWER';
        case HOTEL_LUXOR:
          return 'tile-LUXOR';
        case HOTEL_WORLDWIDE:
          return 'tile-WORLDWIDE';
        case HOTEL_AMERICAN:
          return 'tile-AMERICAN';
        case HOTEL_FESTIVAL:
          return 'tile-FESTIVAL';
        case HOTEL_IMPERIAL:
          return 'tile-IMPERIAL';
        case HOTEL_CONTINENTAL:
          return 'tile-CONTINENTAL';
        default:
          return '';
      }
    }
  },

  methods: {
    onClickTile() {
      this.$emit('click', {
        hotelId: this.hotelId
      });
    }
  }
}
</script>

<style scoped>
.tile {
  user-select: none;
  display: flex;
  background: #787878;
  color: white;
  justify-content: center;
  align-items: center;
  /*padding: 10px 5px;*/
  box-shadow: inset 5px 5px 10px #4e4e4e;
  font-weight: 600;
  /*min-width: 35px;*/
  /*min-height: 25px;*/
  width: 48px;
  height: 48px;
}

.clickable {
  cursor: pointer;
}

.raised-tile {
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*width: 48px;*/
  /*height: 48px;*/
  /*margin: 2px;*/
  /*background-color: #3a3a3a;*/
  /*color: white;*/
  /*cursor: pointer;*/
  /*border-width: 5px;*/
  /*border-style: solid;*/
  /*border-top-color: #5a5a5a;*/
  /*border-left-color: #5a5a5a;*/
  /*border-right-color: #171717;*/
  /*border-bottom-color: #171717;*/
  /*box-sizing: border-box;*/
  /*box-shadow: 1px 1px 4px #848484;*/


  /*margin: 2px;*/
  background-color: #3a3a3a;
  border-width: 5px;
  border-style: solid;
  border-top-color: #5a5a5a;
  border-left-color: #5a5a5a;
  border-right-color: #171717;
  border-bottom-color: #171717;
  box-sizing: border-box;
  box-shadow: 1px 1px 4px #848484;
}

.parent-hotel-tile {
  font-family: 'Rozha One', serif;
  font-size: 28px;
}

.tile-TOWER {
  background: #f2c147;
  /*box-shadow: inset 0 -2px 0 #f2c147;*/
  border-left-color: #ffe6a9;
  border-right-color: #e6ac1a;
  border-bottom-color: #e6ac1a;
  border-top-color: #ffe6a9;
  color: #ffe7ad;
  text-shadow: -1px -1px 0 #a99f88;
}
.tile-LUXOR {
  background: #bd262e;
  /*box-shadow: inset 0 -2px 0 #bd262e;*/
  border-left-color: #e22f38;
  border-right-color: #a92027;
  border-bottom-color: #a92027;
  border-top-color: #e22f38;
  color: #f9a0a4;
  text-shadow: -1px -1px 0 #2d0002;
}
.tile-WORLDWIDE {
  background: #99593c;
  /*box-shadow: inset 0 -2px 0 #99593c;*/
  border-left-color: #c3876c;
  border-right-color: #6d3d28;
  border-bottom-color: #6d3d28;
  border-top-color: #c3876c;
  color: #d6a48d;
  text-shadow: -1px -1px 0 #040302;
}
.tile-AMERICAN {
  background: #154fb7;
  /*box-shadow: inset 0 -2px 0 #154fb7;*/
  border-left-color: #4d7ed6;
  border-right-color: #0b2b63;
  border-bottom-color: #0b2b63;
  border-top-color: #4d7ed6;
  color: #a7c4fb;
  text-shadow: -1px -1px 0 #14233e;
}
.tile-FESTIVAL {
  background: #108657;
  /*box-shadow: inset 0 -2px 0 #108657;*/
  border-left-color: #5aaf8d;
  border-right-color: #0c6541;
  border-bottom-color: #0c6541;
  border-top-color: #5aaf8d;
  color: #6cbf9e;
  text-shadow: -1px -1px 0 #224436;
}
.tile-IMPERIAL {
  background: #00b5c5;
  /*box-shadow: inset 0 -2px 0 #00b5c5;*/
  border-left-color: #6ed1da;
  border-right-color: #028c98;
  border-bottom-color: #028c98;
  border-top-color: #6ed1da;
  color: #83e2ea;
  text-shadow: -1px -1px 0 #2f575a;
}
.tile-CONTINENTAL {
  background: #f17db6;
  /*box-shadow: inset 0 -2px 0 #f17db6;*/
  border-left-color: #f7aad0;
  border-right-color: #d0689b;
  border-bottom-color: #d0689b;
  border-top-color: #f7aad0;
  color: #fdb2d7;
  text-shadow: -1px -1px 0 #82596d;
}

/*.parent-hotel-tile-on-board {*/
/*  box-shadow: 3px 3px 0 #171717;*/
/*  margin-top: -3px;*/
/*  margin-left: -3px;*/
/*}*/

.child-hotel-tile {
  border-top-color: #5a5a5a;
  border-left-color: #5a5a5a;
  border-right-color: #171717;
  border-bottom-color: #171717;
  background-color: #3a3a3a;
}

.hidden {
  visibility: hidden;
}

.my-tile {
  background: #78787896;
  cursor: pointer;
}

.current {
  margin: 0;
  transform: scale(1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.80);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.80);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
</style>
